import { Obligation } from "models/obligation";
import { doGet, doPost } from "../request";

export const userDoGetObligation = async () => {
  const obligation = await doGet<Obligation>(`/user/obligation`);
  return obligation;
};

export const userDoPostObligation = async () => {
  const obligation = await doPost<Obligation>(`/user/obligation`);
  return obligation;
};
